import React from 'react';
import { Mail } from 'lucide-react';
import { GithubIcon, LinkedinIcon } from '../ui/Icons';
import '../../styles/components/SocialLinks.css';

interface SocialLinksProps {
  github?: string;
  linkedin?: string;
  email?: string;
  size?: number;
}

const SocialLinks: React.FC<SocialLinksProps> = ({ github, linkedin, email, size = 20 }) => {
  return (
    <div className="social-links">
      {github && (
        <a
          href={github}
          target="_blank"
          rel="noopener noreferrer"
          className="social-links__link"
          aria-label="GitHub profile"
        >
          <GithubIcon size={size} />
        </a>
      )}
      {linkedin && (
        <a
          href={linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="social-links__link"
          aria-label="LinkedIn profile"
        >
          <LinkedinIcon size={size} />
        </a>
      )}
      {email && (
        <a
          href={`mailto:${email}`}
          className="social-links__link"
          aria-label="Send email"
        >
          <Mail size={size} />
        </a>
      )}
    </div>
  );
};

export default SocialLinks;
